export default __webpack_public_path__ + "static/media/566.5eae77f8.png";